(function () {
	'use strict';

	a3_cabin_reports.service("InfoAPIService", InfoAPIService);

	/**
	* @memberof CabinReports
	* @ngdoc service
	* @name InfoAPIService
	* @description 
	*  Information service which gets latest pax and gate data
	* @ngInject
	*/
	function InfoAPIService($http, $q, apiUrl, LogService, UserFactory, SyncAPIService,
		FlightFactory, PaxInfoFactory, AircaftPositionsFactory, GroundDutyFactory,
		CampaignFactory, LuggageComplianceFactory, FlightCheckInsFactory,
		PhiloxeniaQuestionsFactory, FlightDelaysFactory, CustomerEventHistoryFactory, JeppesenFlightDetailsFactory) {

		return {
			getPax: getPax,
			sendCustomerIncident: sendCustomerIncident,
			refreshCrewRoute: refreshCrewRoute,
			updateCrewRouteStatusSetter: updateCrewRouteStatusSetter,
			updateFlightStatusSetter: updateFlightStatusSetter,
			updateGroundStatusSetter: updateGroundStatusSetter,
			updateStatusSetter: updateStatusSetter,
			updateFlightLocalStorage: updateFlightLocalStorage,
			updateGroundDutyLocalStorage: updateGroundDutyLocalStorage,
			updateCrewCheckIn: updateCrewCheckIn,
			updatePhiloxeniaQuestions: updatePhiloxeniaQuestions
		};

		/**
		 * get latest Passenger information
		 * @memberof InfoAPIService
		 * @return {object} promise
		 */
		function getPax(flightId) {

			//Prepare to request training courses fetch
			var flight = FlightFactory.getFlightFromTotalFlights(flightId);

			var flightInfo = {
				FlightId: flightId,
				FlightCourses: flight ? flight.Courses : []
			};

			var user = UserFactory.getUser();
			var call = $q.defer();

			$http.post(apiUrl + '/info/Pax', flightInfo, { 'Content-Type': 'application/json' })
				.then(
					function (responseData) {
						if (responseData == undefined || responseData.data == undefined || responseData.data.data == undefined) {
							var err = new Error();
							err.status = -1;
							var msg = "ResponseData error in info/gates :" + JSON.stringify(responseData);
							LogService.debug(msg, err)
							call.reject(err);
							return;
						}

						var newDutyInfo = responseData.data.data;
						newDutyInfo.FlightId = flightId;
						updateFlightLocalStorage(newDutyInfo);
						LuggageComplianceFactory.updateLuggageComplianceStorage(newDutyInfo.LuggageCompliance, flightId);
						updateCrewCheckIn(newDutyInfo);
						updatePhiloxeniaQuestions(newDutyInfo);
						FlightDelaysFactory.upsertFlightDelays(newDutyInfo.FlightDelays);

						call.resolve(responseData);
					},
					function (err) {
						call.reject(err);
					}
				);
			return call.promise;
		}

		/**
		 * Send Customer Incident
		 * @memberof InfoAPIService
		 * @return {object} promise
		 */
		function sendCustomerIncident(flightDescription, question, description, imageStr) {

			var user = UserFactory.getUser();
			var call = $q.defer();
			var customerIncident = { flightDescription: flightDescription, question: question, description: description, image: imageStr }
			$http.post(apiUrl + '/customer/Incident', customerIncident, { 'Content-Type': 'application/json' })
				.then(
					function (responseData) {
						if (responseData == undefined || responseData.data == undefined || responseData.data.data == undefined) {
							var err = new Error();
							err.status = -1;
							var msg = "ResponseData error in customer/Incident :" + JSON.stringify(responseData);
							LogService.debug(msg, err)
							call.reject(err);
							return;
						}
						call.resolve(responseData);
					},
					function (err) {
						call.reject(err);
					}
				);
			return call.promise;
		}

		/**
		 * Gets latest info for each duty in a crew route
		 * @memberof InfoAPIService
		 * @param {object} crewRouteDuty 
		 * @param {function} callback 
		 */
		function refreshCrewRoute(crewRouteDuty, callback) {
			var crewRouteInfo = {
				DutyNo: crewRouteDuty.DutyNo,
				DutyDay: crewRouteDuty.DutyDay,
				Route: crewRouteDuty.Route,
				From: crewRouteDuty.DutyBegin,
				To: crewRouteDuty.DutyEnd,
				FlightCourses: crewRouteDuty.Courses,
				CurrentDutyDate: crewRouteDuty.CurrentDutyDate
			};

			//refresh route for the current day (Flight page)
			if (crewRouteDuty.CurrentDutyDate) {
				return $http.post(apiUrl + '/info/RefreshFlight', crewRouteInfo, { 'Content-Type': 'application/json' })
					.then(callback);
			}
			//Refresh whole Crew Route (Crew Route page)
			else {
				return $http.post(apiUrl + '/info/RefreshCrewRoute', crewRouteInfo, { 'Content-Type': 'application/json' })
					.then(callback);
			}

		}

		/**
		 * Updates Route's Data Status depending on Refresh respond
		 * @memberof InfoAPIService
		 * @param {object} newDuty - Refresh respond
		 * @param {array} dataStatus 
		 */
		function updateCrewRouteStatusSetter(dataStatus, crewRouteStatuses) {
			if (crewRouteStatuses.meals) {
				updateStatusSetter(dataStatus, ["Meals"], "SUCCESS", "Successfully updated");
			}
			else {
				updateStatusSetter(dataStatus, ["Meals"], "N/A", "No available data");
			}

			if (crewRouteStatuses.airportContacts) {
				updateStatusSetter(dataStatus, ["Airport Contacts"], "SUCCESS", "Successfully updated");
			}
			else {
				updateStatusSetter(dataStatus, ["Airport Contacts"], "N/A", "No available data");
			}

			if (crewRouteStatuses.groundServices) {
				updateStatusSetter(dataStatus, ["Ground Services"], "SUCCESS", "Successfully updated");
			}
			else {
				updateStatusSetter(dataStatus, ["Ground Services"], "N/A", "No available data");
			}

			if (crewRouteStatuses.aircraftDifferences) {
				updateStatusSetter(dataStatus, ["Aircraft Differences"], "SUCCESS", "Successfully updated");
			}
			else {
				updateStatusSetter(dataStatus, ["Aircraft Differences"], "N/A", "No available data");
			}

			if (crewRouteStatuses.campaigns) {
				updateStatusSetter(dataStatus, ["Campaigns"], "SUCCESS", "Successfully updated");
			}
			else {
				updateStatusSetter(dataStatus, ["Campaigns"], "N/A", "No available data");
			}

			if (crewRouteStatuses.airportHotels) {
				updateStatusSetter(dataStatus, ["Hotels"], "SUCCESS", "Successfully updated");
			}
			else {
				updateStatusSetter(dataStatus, ["Hotels"], "N/A", "No available data");
			}

			if (crewRouteStatuses.crewAimsMemos) {
				updateStatusSetter(dataStatus, ["Aims Memos"], "SUCCESS", "Successfully updated");
			}
			else {
				updateStatusSetter(dataStatus, ["Aims Memos"], "N/A", "No available data");
			}

			if (crewRouteStatuses.flightServiceEvents) {
				updateStatusSetter(dataStatus, ["Flight Service Events"], "SUCCESS", "Successfully updated");
			}
			else {
				updateStatusSetter(dataStatus, ["Flight Service Events"], "N/A", "No available data");
			}

			if (crewRouteStatuses.misconnectionFlights) {
				updateStatusSetter(dataStatus, ["Misconnection Flights"], "SUCCESS", "Successfully updated");
			}
			else {
				updateStatusSetter(dataStatus, ["Misconnection Flights"], "N/A", "No available data");
			}
		}
		/**
		 * Updates Flight's Data Status depending on Refresh respond
		 * @memberof InfoAPIService
		 * @param {object} newDuty - Refresh respond
		 * @param {array} dataStatus 
		 */
		function updateFlightStatusSetter(newDuty, dataStatus) {

			if (newDuty.FlightInfo) {
				updateStatusSetter(dataStatus, ["Flight Status"], "SUCCESS", "Successfully updated");
			} else {
				updateStatusSetter(dataStatus, ["Flight Status"], "N/A", "No available data");
			}

			if (newDuty.AircraftPositions && newDuty.AircraftPositions.length > 0) {
				updateStatusSetter(dataStatus, ["Aircraft Movement"], "SUCCESS", "Successfully updated");
			} else {
				updateStatusSetter(dataStatus, ["Aircraft Movement"], "N/A", "No available data");
			}

			if (newDuty.FlightInfo && newDuty.FlightInfo.crew && newDuty.FlightInfo.crew.length > 0) {
				updateStatusSetter(dataStatus, ["Crew Info"], "SUCCESS", "Successfully updated");
			} else {
				updateStatusSetter(dataStatus, ["Crew Info"], "N/A", "No available data");
			}

			if (newDuty.FlightInfo && newDuty.FlightInfo.crew && newDuty.FlightInfo.crew.length > 0 && newDuty.FlightInfo.crew.filter(x => x.PhoneNumber != null).length > 0) {
				updateStatusSetter(dataStatus, ["Crew Contacts"], "SUCCESS", "Successfully updated");
			} else {
				updateStatusSetter(dataStatus, ["Crew Contacts"], "N/A", "No available data");
			}

			if (newDuty.CabinServiceManagementLists && newDuty.CabinServiceManagementLists.length > 0 && newDuty.CabinServiceManagementLists[0].ConnectingFlights && newDuty.CabinServiceManagementLists[0].ConnectingFlights.length > 0) {
				updateStatusSetter(dataStatus, ["Connections"], "SUCCESS", "Successfully updated");
			} else {
				updateStatusSetter(dataStatus, ["Connections"], "N/A", "No available data");
			}

			if (newDuty.CabinServiceManagementLists && newDuty.CabinServiceManagementLists.length > 0 && newDuty.CabinServiceManagementLists[0].ConnectingFlights && newDuty.CabinServiceManagementLists.length > 0) {
				updateStatusSetter(dataStatus, ["Pax Info"], "SUCCESS", "Successfully updated");
			} else {
				updateStatusSetter(dataStatus, ["Pax Info"], "N/A", "No available data");
			}

			if (newDuty.LuggageCompliance && newDuty.LuggageCompliance.length > 0) {
				updateStatusSetter(dataStatus, ["Luggage Info"], "SUCCESS", "Successfully updated");
			} else {
				updateStatusSetter(dataStatus, ["Luggage Info"], "N/A", "No available data");
			}

			if (newDuty.TrainingCourses && newDuty.TrainingCourses.length > 0) {
				updateStatusSetter(dataStatus, ["Training Info"], "SUCCESS", "Successfully updated");
			} else {
				updateStatusSetter(dataStatus, ["Training Info"], "N/A", "No available data");
			}

			if (newDuty.ShopInTheCloudIsUpdated) {
				updateStatusSetter(dataStatus, ["Shop In The Cloud"], "SUCCESS", "Successfully updated");
			} else {
				updateStatusSetter(dataStatus, ["Shop In The Cloud"], "N/A", "No available data");
			}

		}

		/**
		 * Updates Ground Duty's Data Status depending on Refresh respond
		 * @memberof InfoAPIService
		 * @param {array} newDuty - Refresh respond
		 * @param {array} dataStatus 
		 */
		function updateGroundStatusSetter(newDuty, dataStatus) {
			if (newDuty) {
				updateStatusSetter(dataStatus, ["Duty Info"], "SUCCESS", "Successfully updated");
			} else {
				updateStatusSetter(dataStatus, ["Duty"], "N/A", "No available data");
			}

			if (newDuty && newDuty.RelatedGroundDuties && newDuty.RelatedGroundDuties.length > 1) {
				updateStatusSetter(dataStatus, ["Instructors"], "SUCCESS", "Successfully updated");
				updateStatusSetter(dataStatus, ["Trainees"], "SUCCESS", "Successfully updated");
			} else {
				updateStatusSetter(dataStatus, ["Instructors"], "N/A", "No available data");
				updateStatusSetter(dataStatus, ["Trainees"], "N/A", "No available data");
			}
		}


		/**
		 * Changes the state of Data Status
		 * @memberof InfoAPIService
		 * @param {array} dataStatus 
		 * @param {array} array - Datatype to change
		 * @param {string} status - New status
		 * @param {string} text - New text
		 */
		function updateStatusSetter(dataStatus, array, status, text) {

			var objsTochange = dataStatus.filter(function (x) {
				var res = array.filter(function (s) { return s == x.datatype });
				return res.length > 0 ? true : false;
			});

			objsTochange.forEach(function (x) {
				x.status = status;
				x.text = text;

				var index = dataStatus.map(function (x) { return x.datatype }).indexOf(x.datatype);
				dataStatus[index] = x;
			});

		}

		/**
		 * Update Flight Info in Local Storage
		 * @memberof InfoAPIService
		 * @param {object} duty 
		 */
		function updateFlightLocalStorage(duty) {
			// save flight gates to local storage
			//var flightGates = duty.FlightGates;
			//FlightGateFactory.processUpdatedData(flightGates);

			//Update Aircraft positions
			if (duty.AircraftPositions != null && duty.AircraftPositions.length > 0) {
				AircaftPositionsFactory.updateAircraftPositionsToStorage(duty.AircraftPositions[0], duty.FlightInfo.FlightId);
			}
			// update flight to local storage
			FlightFactory.mergeFlightInfo(duty.FlightInfo, duty.ShowPaxNames);
			//Enrich flight info after sync
			SyncAPIService.updateCabinReportLocalEditFromSynch();
			// update paxinfo to local storage

			if (duty.CabinServiceManagementLists && duty.CabinServiceManagementLists.length > 0) {
				PaxInfoFactory.updatePaxInfo(duty.CabinServiceManagementLists[0]);
			}


			if (duty.Campaigns && duty.Campaigns.FlightsCampaigns.length > 0) {
				if (duty.CabinServiceManagementLists) {
					CampaignFactory.updateSeatNoPaxAssignments(duty.Campaigns.FlightsCampaigns, duty.CabinServiceManagementLists);
				}
				CampaignFactory.mergeCampaigns(duty.Campaigns);
			}

			if (duty.CustomerEventHistory && duty.CustomerEventHistory.length) {
				CustomerEventHistoryFactory.refreshPassengerHistory(duty.CustomerEventHistory);
			}

			if (duty.JeppesenFlightDetails && duty.FlightInfo && duty.FlightInfo.FlightId) {
				JeppesenFlightDetailsFactory.setJeppesenFlightDetailsToStorage(
					duty.FlightInfo.FlightId,
					duty.JeppesenFlightDetails
				);

				if (Array.isArray(duty.CTOTHistory)) {
					JeppesenFlightDetailsFactory.setCtotHistoryToStorage(
						duty.FlightInfo.FlightId,
						duty.CTOTHistory
					);
				}
			}

			// update messages to local storage
			// MessageFactory.markReadAsSynched(duty.Messages);
			// MessageFactory.storeMessagesFromServer(duty.Messages);


		}

		/**
		 * Update Ground Duty Info in Local Storage
		 * @memberof InfoAPIService
		 * @param {object} duty 
		 */
		function updateGroundDutyLocalStorage(duty) {
			GroundDutyFactory.mergeGroundDutyInfo(duty);
		}

		/**
		 * Update Flight crew check-in Info in Local Storage
		 * @memberof InfoAPIService
		 * @param {object} duty 
		 */
		function updateCrewCheckIn(duty) {
			if (duty.FlightInfo) {
				FlightCheckInsFactory.updateFlightCrewCheckInToStorage(duty);
			}
		}

		/**
		 * Update Philoxenia Questions for the current flight in Local Storage
		 * @memberof InfoAPIService
		 * @param {object} duty 
		 */
		function updatePhiloxeniaQuestions(duty) {
			if (duty.PhiloxeniaQuestions) {
				PhiloxeniaQuestionsFactory.updatePhiloxeniaQuestionsToStorage(duty.PhiloxeniaQuestions);
			}
		}
	}

})();